import React from 'react';
import {
  GraphsContainer,
  GraphsContainerProps,
  GraphsContainerRoot,
} from 'src/common/components/AppLayout/Components/Graphs/GraphsContainer';
import { styled } from '@mui/material/styles';

const MOVE_UP_MARGIN = -12;
const SPACING_BETWEEN_GRAPHS_TABLE = 20;
const SHOW_OVERVIEW_BUTTON_HEIGHT = 44 + (SPACING_BETWEEN_GRAPHS_TABLE + MOVE_UP_MARGIN);

type PageWithGraphsProps =
  | {
      children: React.ReactNode;
    }
  | {
      children: React.ReactNode;
      graphs: React.ReactNode;
      slots: {
        graphsContainer: Omit<GraphsContainerProps, 'children'>;
      };
    };

const PageWithGraphsContent = styled('div', { name: 'PageWithGraphsContent' })(({ theme }) => ({
  height: `calc(100vh - ${theme.spacing(60)})`,
  paddingBottom: theme.spacing(20),
  display: 'flex',
  flexDirection: 'column',
}));

const PageWithGraphsRoot = styled('div', { name: 'PageWithGraphsRoot' })(({ theme }) => ({
  marginTop: 0,

  [`&:has(${GraphsContainerRoot})`]: {
    marginTop: theme.spacing(MOVE_UP_MARGIN),

    [`${PageWithGraphsContent}`]: {
      marginTop: theme.spacing(SPACING_BETWEEN_GRAPHS_TABLE),
      height: `calc(100vh - ${theme.spacing(60)} - ${theme.spacing(SHOW_OVERVIEW_BUTTON_HEIGHT)})`,
    },
  },
}));

export const PageWithGraphs = ({ children, ...props }: PageWithGraphsProps) => {
  return (
    <PageWithGraphsRoot>
      {'graphs' in props && (
        <GraphsContainer {...props.slots.graphsContainer}>{props.graphs}</GraphsContainer>
      )}
      <PageWithGraphsContent>{children}</PageWithGraphsContent>
    </PageWithGraphsRoot>
  );
};
